import React, { useState } from "react";
import {
  useNavigate,
  useLocation,
} from "react-router-dom";
import AppFooter from "../components/AppFooter";
import { ArrowLeft, Check, Store } from "lucide-react";

const STORES_KEY = "ezwinds_stores";
const getStores = () => {
  try {
    return JSON.parse(
      localStorage.getItem(STORES_KEY) || "[]"
    );
  } catch { return []; }
};
const saveStores = (list) =>
  localStorage.setItem(
    STORES_KEY,
    JSON.stringify(list)
  );

export default function CreateStorePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const existingStore =
    location.state?.store || null;
  const isEdit = !!existingStore;

  const [name, setName] = useState(
    existingStore?.name || ""
  );
  const [address, setAddress] = useState(
    existingStore?.address || ""
  );
  const [error, setError] = useState("");

  const inputCls = `w-full bg-gray-100
    rounded-xl px-4 py-3 text-sm
    text-gray-900 border border-transparent
    outline-none focus:bg-white
    focus:border-blue-500
    focus:ring-1 focus:ring-blue-500
    transition-colors`;

  const handleSave = () => {
    if (!name.trim()) {
      setError("Store name is required.");
      return;
    }
    setError("");
    const stores = getStores();

    if (isEdit) {
      const updated = stores.map((s) => {
        if (s.id === existingStore.id) {
          return {
            ...s,
            name: name.trim(),
            address: address.trim(),
          };
        }
        return s;
      });
      saveStores(updated);
    } else {
      const newStore = {
        id: Date.now().toString(),
        name: name.trim(),
        address: address.trim(),
        isDefault: stores.length === 0,
        createdAt: new Date().toISOString(),
      };
      const updated = [...stores, newStore];
      saveStores(updated);
    }

    navigate("/stores");
  };

  return (
    <div className="min-h-screen bg-gray-100
      flex flex-col">

      {/* HEADER */}
      <div className="bg-white px-4 pt-5 pb-4
        border-b border-gray-100 shadow-sm
        flex items-center gap-3 flex-shrink-0">
        <button
          type="button"
          onClick={() => navigate("/stores")}
          className="flex items-center gap-1.5
            text-sm text-gray-600 border
            border-gray-200 px-3 py-1.5
            rounded-full flex-shrink-0"
        >
          <ArrowLeft size={13} /> Back
        </button>
        <div>
          <h1 className="text-xl font-extrabold
            text-gray-900">
            {isEdit ? "Edit store" : "Create store"}
          </h1>
          <p className="text-xs text-gray-500">
            {isEdit
              ? existingStore.name
              : "Add a new store location"}
          </p>
        </div>
      </div>

      {/* BODY */}
      <div className="flex-1 px-4 pt-5 pb-28
        max-w-lg w-full mx-auto">
        <div className="bg-white rounded-2xl
          shadow-sm border border-gray-100 p-5">

          <div className="flex justify-center mb-5">
            <div className="w-16 h-16 rounded-2xl
              bg-blue-50 flex items-center
              justify-center">
              <Store size={28}
                className="text-blue-600" />
            </div>
          </div>

          {error && (
            <p className="text-xs text-red-500
              bg-red-50 border border-red-200
              rounded-xl px-3 py-2 mb-4">
              {error}
            </p>
          )}

          <div className="space-y-3">
            <div>
              <label className="text-xs
                text-gray-600 font-medium
                mb-1 block">
                Store name
                <span className="text-red-400
                  ml-0.5">*</span>
              </label>
              <input
                type="text"
                placeholder="e.g. Surya Indian Grocery"
                value={name}
                onChange={(e) =>
                  setName(e.target.value)}
                className={inputCls}
                autoFocus
              />
            </div>

            <div>
              <label className="text-xs
                text-gray-600 font-medium
                mb-1 block">
                Location
              </label>
              <input
                type="text"
                placeholder="e.g. Yonkers, NY"
                value={address}
                onChange={(e) =>
                  setAddress(e.target.value)}
                className={inputCls}
              />
            </div>
          </div>

          <button
            type="button"
            onClick={handleSave}
            className="w-full bg-blue-600
              text-white font-bold text-sm
              py-4 rounded-full mt-5 flex
              items-center justify-center gap-2"
          >
            <Check size={15} />
            {isEdit
              ? "Save changes"
              : "Create store"}
          </button>
        </div>
      </div>

      <AppFooter />
    </div>
  );
}
